<div class="titlebar">
  <h3>{{ "Template.CommonMainComponent.subHeader_EkMedienCenter" | translate }}</h3>
</div>
<fa-icon icon="spinner" animation="spin"></fa-icon>

<ng-template #changePasswordModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ "Template.CommonMainComponent.subHeader_changePassword" | translate }}</h4>
    </div>
    <div class="modal-body">
      <div>
        <app-password-change-form [username]="currentUser?.username!" (exitFormEvent)="exitPasswordForm($event)"></app-password-change-form>
      </div>

      @if (error) {
        <p class="alert alert-danger text-center mt-3">
          <strong>{{ error }}</strong>
        </p>
      }
    </div>
  </div>
</ng-template>

<ng-template #ssoSignupModal let-modal>
  <app-sso-signup-modal></app-sso-signup-modal>
</ng-template>
